import Model, { attr, belongsTo } from '@ember-data/model';

export default class ProjectFileModel extends Model {
  @belongsTo('project', { inverse: null, async: false }) project;
  @attr('string') path;
  @attr('string') fileType;
}
